import { HttpClient } from "../../../../app/api/HttpClient"

export const API_PREFIX_PATH = "/api/translations"

export const fetchTranslations = async (searchTerms: { [key: string]: string } = {}) => {
  const params: Record<string, any> = {
    sort: "updatedAt:desc",
    publicationState: "preview",
    filters: {},
    pagination: { pageSize: "20" },
  }

  const excludedKeys = ["current", "pageSize", "start", "limit", "total", "page"]

  Object.keys(searchTerms).forEach(key => {
    const value = searchTerms[key]

    if (key === "sort") {
      if (value) params.sort = value
      return
    }

    if (!excludedKeys.includes(key)) {
      if (value) {
        if (key === "key") {
          params.filters.$or = [
            { key: { $containsi: value } },
            { vi: { $containsi: value } },
            { en: { $containsi: value } },
            { cs: { $containsi: value } },
          ]
        } else if (key === "website") {
          params.filters.website = { $eq: value }
        }
      }
    } else if (value) {
      params.pagination = { ...params.pagination, [key]: value }
    }
  })

  return await HttpClient.get(API_PREFIX_PATH, { params })
}

export const getTranslationById = async (id: number) => {
  const response = await HttpClient.get(`${API_PREFIX_PATH}/${id}`)
  return response?.data
}

export const createTranslation = async (data: Record<string, any>) => {
  return await HttpClient.post(API_PREFIX_PATH, { data })
}

export const updateTranslation = async (id: string, data: Record<string, any>) => {
  return await HttpClient.put(`${API_PREFIX_PATH}/${id}`, { data })
}

export const deleteTranslation = async (id: number) => {
  return await HttpClient.delete(`${API_PREFIX_PATH}/${id}`)
}

/**
 * Returns true if a translation with the same key+website already exists.
 * Pass excludeId in edit mode so we don't flag the record being edited.
 * NOTE: For true uniqueness safety, add a unique constraint on [key, website]
 * in Strapi as well — this frontend check is a best-effort guard.
 */
export const checkKeyWebsiteExists = async (
  key: string,
  website: string,
  excludeId?: number,
): Promise<boolean> => {
  const params: Record<string, any> = {
    filters: {
      key: { $eq: key },
      website: { $eq: website },
    },
    fields: ["id"],
    publicationState: "preview",
  }
  const response = await HttpClient.get(API_PREFIX_PATH, { params })
  const items: Array<{ id: number }> = Array.isArray(response?.data) ? response.data : []
  if (excludeId) {
    return items.some(item => item.id !== excludeId)
  }
  return items.length > 0
}
